import {Box, Grid} from '@primer/react-brand'

import {ContentfulPillars} from '@github-ui/swp-core/components/contentful/ContentfulPillars'
import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'
import type {PrimerPillars} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerPillars'

import type {GenericSectionWithIds} from '../../../../brand/lib/types/contentful'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function PillarsSection(props: Props) {
  const {contentfulContent} = props
  const {content, sectionIntro} = contentfulContent.fields

  const pillarsComponent = content?.find(item => item.sys.contentType.sys.id === 'primerPillars') as
    | PrimerPillars
    | undefined

  if (!pillarsComponent) {
    return null
  }

  return (
    <Grid as="section">
      <Grid.Column span={12}>
        {sectionIntro ? (
          <ContentfulSectionIntro component={sectionIntro} fullWidth headingSize="3" className="tmp-mb-6" />
        ) : null}

        <ContentfulPillars component={pillarsComponent} />
      </Grid.Column>
      <Grid.Column span={12}>
        <Box
          marginBlockEnd={{narrow: 48}}
          paddingBlockEnd={{narrow: 48}}
          borderBlockEndWidth="thin"
          borderColor="default"
          borderStyle="solid"
        />
      </Grid.Column>
    </Grid>
  )
}
